let IS_CURRENTLY_RUNNING = false

class GuideWatcher {
  constructor (_isCancelled, execFunc, _instructor) {
    this._isCancelled = _isCancelled
    this._instructor = _instructor
    this.reset(execFunc)
  }
  reset (execFunc) {
    if (this._isCancelled) return
    this.execFunc = execFunc
    clearTimeout(this._timer)
    let _this = this
    this._timer = setTimeout(function () {
      _this.exec()
    }, this._instructor.timeoutDur)
  }
  exec () {
    if (IS_CURRENTLY_RUNNING) {
      this.reset(this.execFunc)
      return
    }
    if (this.execFunc) {
      this.execFunc()
    }
    this._instructor.cancel()
    this._instructor = null
  }
  destory () {
    this.execFunc = null
    clearTimeout(this._timer)
  }
  cancel () {
    this._isCancelled = true
    this.destory()
  }
}

class GuideInstruction {
  constructor (name, timeoutDur) {
    this.name = name
    this.timeoutDur = timeoutDur
    this._isCancelled = false
  }
  cancel () {
    if (this._isCancelled) return
    this._isCancelled = true
    if (this._watcher) this._watcher.cancel()
  }
  getWatcher (execFunc) {
    if (this._watcher) {
      if (this._isCancelled) {
        this._watcher.cancel()
      } else {
        this._watcher.reset(execFunc)
      }
    } else {
      this._watcher = new GuideWatcher(this._isCancelled, execFunc, this)
    }
    return this._watcher
  }
}

export default {
  mainNavThumb: new GuideInstruction('mainNavThumb', 20000),
  carousel: new GuideInstruction('carousel', 15000),
  howToRunning () {
    if (IS_CURRENTLY_RUNNING) return
    IS_CURRENTLY_RUNNING = true
  },
  howToComplete () {
    if (!IS_CURRENTLY_RUNNING) return
    IS_CURRENTLY_RUNNING = false
  },
  isRunning () {
    return IS_CURRENTLY_RUNNING
  }
}
